// extracted by mini-css-extract-plugin
var _1 = "GssDD";
var _2 = "Gd_12";
var _3 = "F_Q0i";
export { _1 as "adsContainer", _2 as "bottom", _3 as "hide" }
